import BuildIcon from '@mui/icons-material/Build'; // Per Manutenzione Preventiva
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber'; // Per Ticket
import HistoryIcon from '@mui/icons-material/History'; // Per Registro Attività
import { Box, Typography } from '@mui/material';
import { DateTimeCell, TypeCell, OperatorCell } from 'components/cells';
import { IEquipmentLogBookItem } from 'features/inventory/equipments/types';
import React from 'react';

export const EQUIPMENT_LOG_REGISTRY = {
  'technical-assistance': {
    label: 'Ticket',
    IconComponent: ConfirmationNumberIcon,
    basePath: '/tenant/equipments/ticketing'
  },
  'preemptive-maintenance': {
    label: 'Manutenzione preventiva',
    IconComponent: BuildIcon,
    basePath: '/tenant/equipments/maintenance'
  },
  'equipment-activity': {
    label: 'Attività',
    IconComponent: HistoryIcon,
    basePath: '/tenant/activities'
  },
  checklist: {
    label: 'Checklist',
    IconComponent: CheckCircleIcon,
    basePath: '/tenant/equipments/checklist'
  }
};

export const LOGBOOK_COLUMNS: Array<{
  field: string;
  label?: string;
  numeric?: boolean;
  sortable?: boolean;
  align?: 'left' | 'center' | 'right';
  renderCell?: (params: { row: IEquipmentLogBookItem; index: number }) => React.ReactNode;
}> = [
  {
    field: 'event_date',
    sortable: true,
    align: 'left',
    renderCell: ({ row }) => <DateTimeCell eventDate={row.event_date} />
  },
  {
    field: 'event_type',
    sortable: false,
    align: 'left',
    renderCell: ({ row }) => (
      <TypeCell
        typeSlug={row.event_type_slug}
        fallbackLabel={row.event_type?.toUpperCase()}
        registry={EQUIPMENT_LOG_REGISTRY}
      />
    )
  },
  {
    field: 'event_description',
    sortable: false,
    align: 'left',
    renderCell: ({ row }) => (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
        {/* SUB TYPE (Sopra, stile etichetta/codice) */}
        {row.sub_type && (
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              textTransform: 'uppercase',
              color: 'primary.main',
              letterSpacing: '0.5px',
              fontSize: '0.75rem'
            }}>
            {row.sub_type.replace('_', ' ')}
          </Typography>
        )}

        {/* DESCRIZIONE (Sotto, troncata con tooltip nativo) */}
        <Typography
          variant="body2"
          sx={{
            maxWidth: '500px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: 'text.primary'
          }}
          title={row.event_description || ''}>
          {row.event_description || 'Nessun dettaglio registrato.'}
        </Typography>
      </Box>
    )
  },
  {
    field: 'operator',
    sortable: false,
    align: 'left',
    renderCell: ({ row }) => {
      if (!row.operator || !row.operator.username) {
        return (
          <Box sx={{ color: 'text.secondary', fontSize: '0.85rem', fontStyle: 'italic' }}>
            Sistema
          </Box>
        );
      }

      return <OperatorCell operator={row.operator} />;
    }
  }
];
